import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Slider,
  Space,
  Table,
  InputNumber
} from "antd";
import React, { useState, useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import moment from "moment";
import transmissionService from "@services/transmission.service";
import ExportCSV from "@components/ExportCSV";

const { RangePicker } = DatePicker;

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
};
/* eslint-enable no-template-curly-in-string */

const IG30028 = () => {
  const [mounted, setMounted] = useState(false);
  const [threshold, setThreshold] = useState(20);
  const [submitted, setSubmitted] = useState(false);
  const [filtredDataSet, setFiltredDataSet] = useState([]);
  const [dataSet, setDataSet] = useState([]);
  const [columns, setColumns] = useState([]);
  const [searchObj, setSearchObj] = useState({
    searchText: "",
    searchedColumn: "",
  });

  const [form] = Form.useForm();



  const onFinish = async ({ date, ...values }) => {
    setSubmitted(true);
    try {
      const { data } = await transmissionService.Post(("/IG30028"), {
        ...values,
        threshold: threshold,
        startDate: moment(date[0]).toISOString(),
        endDate: moment(date[1]).toISOString(),
      });

      setDataSet(data);
      setFiltredDataSet(data);

      let tmpColumns = [];
      const row = data[0];
      Object.keys(row).forEach((key) =>
        tmpColumns.push({
          key: key,
          title: key,
          dataIndex: key,
          className: "whitespace-nowrap",
          ...getColumnSearchProps(key),
          sorter: (a, b) => +(a[key] > b[key]) || -(a[key] < b[key]),
          sortDirections: ["descend", "ascend"],
        })
      );
      setColumns(tmpColumns);
    } catch (err) {
      console.log(err);
    } finally {
      setSubmitted(false);
    }
  };

  function getColumnSearchProps(dataIndex) {
    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              searchObj.searchInput = node;
            }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={() => handleReset(clearFilters, confirm)}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                confirm({ closeDropdown: false });
                setSearchObj({
                  searchText: selectedKeys[0],
                  searchedColumn: dataIndex,
                });
              }}
            >
              Filter
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
          : "",
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => searchObj.searchInput.select(), 100);
        }
      },
      render: (text) =>
        searchObj.searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchObj.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    };
  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchObj({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchObj({ searchText: "" });
  };

  const handleChange = (pagination, filters, sorter, { currentDataSource }) => {
    setFiltredDataSet(currentDataSource);
  };

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  return (
    <div className="space-y-5">
      <div className="bg-white rounded-md border border-gray-200 p-5">
        <Form
          form={form}
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
        >
          <Row gutter={[14, 0]}>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
              <Form.Item
                name="date"
                label="Date"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <RangePicker />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>

              <Form.Item
                className="flex-grow"
                name="threshold"

                label={`Threshold`}

              >
                <InputNumber min={1} max={500} value={threshold} defaultValue={20} onChange={(value) => setThreshold(value)} />
              </Form.Item>

            </Col>

            <Col flex="auto" className="flex justify-start items-end">
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={submitted}
                  className="mt-4"
                >
                  Search
                </Button>
                <Button
                  style={{ margin: "0 8px" }}
                  onClick={() => {
                    form.resetFields();
                  }}
                >
                  Clear
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>

      <div className="">
        <ExportCSV
          dataSet={filtredDataSet}
          fileName="RSL-Reports"
          loading={submitted || filtredDataSet.length === 0}
        />
      </div>

      <Table
        scroll={{ scrollToFirstRowOnChange: true, x: "480px" }}
        onChange={handleChange}
        dataSource={[...dataSet]}
        loading={submitted}
        columns={[...columns]}
      />
    </div>
  );
};

export default IG30028;
